/** @prettier */
// @flow

import { setSandboxMode } from '../helpers/sandbox';
import { setEnableLongDescription } from './enableLongDescription';
import { setHideGdprConsent } from './hideGdprConsent';
import * as login from './login';
import { setPaystationCustomParameters } from './pay-station-custom-parameters';
import { setPaystationWidgetUISettings } from './payStationWidgetSettings';
import { setShowCustomParamsUserId } from './showCustomParamsUserId';
import { setIsCustomPayStationTheme } from './showCustomPayStationTheme';
import { setShowHeaderLineMenu } from './showHeaderLineMenu';
import { setShowPriceInButton } from './showPriceInButton';
import * as subscribeBlock from './subscribeBlock';

export { init } from '@site-builder/common/src/landingAPI';

export const setupBlocksAPI = (window: Object) => {
  window.SB = Object.assign({}, window.SB, {
    setSandboxMode,
    login,
    setShowCustomParamsUserId,
    setEnableLongDescription,
    setHideGdprConsent,
    setShowHeaderLineMenu,
    setShowPriceInButton,
    setIsCustomPayStationTheme,
    setPaystationCustomParameters,
    setPaystationWidgetUISettings,
    subscribeBlock,
  });
  window.SB._callbacks.forEach((cb) => cb(window.SB));
};
